import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError, map, switchMap, tap, withLatestFrom, concatMap, mapTo } from 'rxjs/operators';
import { Actions, ofType, Effect } from '@ngrx/effects';
import { Action, Store, select } from '@ngrx/store';
import * as invoiceActions from '../actions/invoice.actions';
import * as fromUI from '../actions/ui.actions';
import { of } from 'rxjs';  
import { InvoiceService } from '../../shared/services/invoice.service';
import { PrestationService } from '../../shared/services/prestation.service';
import { NotificationsService } from '../../shared/notifications/notifications.service';
import { Location } from '@angular/common';

@Injectable()
export class InvoiceEffect {

    @Effect()
    loadInvoices$: Observable<any> = this.actions$.pipe(
        ofType(invoiceActions.LOAD_INVOICES), 
        switchMap((action) => {   
            return this.invoiceService.getAll(        action['sortField'],
                action['sortOrder'],
                action['filters'],
                action['first'], 
                action['rows'], 
                action['outInvoices'], 
                ).pipe(
                map((res: any) => new invoiceActions.LoadInvoicesSuccessAction(res.body,parseInt(res.headers.get('X-Pagination-Total-Count')))),
                catchError(error => of(new invoiceActions.LoadInvoicesErrorAction(error)))
            );
        })        
    );

    @Effect()
    openTab$: Observable<any> = this.actions$.pipe(
        ofType(invoiceActions.OPEN_TAB),        
        switchMap((action) => {            
            return this.invoiceService.get(action['id']).pipe(
                map((res: any) => new invoiceActions.LoadInvoiceSuccessAction(res)),
                catchError(error => of(new invoiceActions.LoadInvoiceErrorAction(error)))
            );
        })
    );    
    @Effect()
    saveInvoice$: Observable<any> = this.actions$.pipe(
        ofType(invoiceActions.SAVE_INVOICE),        
        map((action: invoiceActions.SaveInvoiceAction) => action ),
        switchMap((action) => { 
            return this.invoiceService.save(action.invoice).pipe(
                map((res: any) => new invoiceActions.SaveInvoiceSuccessAction(action['invoice']['id'], res)),
                catchError(error => of(new invoiceActions.SaveInvoiceErrorAction(action['invoice']['id'], error)))
            );
        })
    );    

    @Effect({ dispatch: false })
    addInvoice: Observable<any> = this.actions$.pipe(
        ofType(invoiceActions.ADD_INVOICE),        
        concatMap(action =>
            of(action).pipe(
              withLatestFrom(this.store.pipe(select('invoice')))
            )
        ),        
        tap(a => {
                console.log('route to ', '/compta/view/' + a[1].lastNewId);
               this.router.navigateByUrl('/compta/view/' + a[1].lastNewId);
        })

    );

    @Effect({ dispatch: false })
    closeTab$: Observable<any> = this.actions$.pipe(
        ofType(invoiceActions.CLOSE_TAB),        
        concatMap(action =>
            of(action).pipe(
              withLatestFrom(this.store.pipe(select('invoice')))
            )
        ),        
        tap(a => {
            this.router.navigateByUrl('/compta/sortie');
        })

    );

    @Effect()
    invoiceWorkflow: Observable<any> = this.actions$.pipe(
        ofType(invoiceActions.INVOICE_WORKFLOW),        
        map((action: invoiceActions.InvoiceWorkflowAction) => action ),
        switchMap((action) => { 
                    
            if (action.action === 'send-peppol') {
                return this.invoiceService.sendPeppol(action.id).pipe(
                    map((res: any) => new invoiceActions.SaveInvoiceSuccessAction(action['id'], res)),
                    catchError(error => of(new invoiceActions.InvoiceWorkflowErrorAction(action['id'], error)))
                );
            } else {
                return this.invoiceService.doWorkflow(action.id, action.action).pipe(
                    map((res: any) => new invoiceActions.InvoiceWorkflowSuccessAction(action['id'], res)),
                    catchError(error => of(new invoiceActions.InvoiceWorkflowErrorAction(action['id'], error)))
                );
            }
        })
    );    

    @Effect()
    deleteInvoice$: Observable<any> = this.actions$.pipe(
        ofType(invoiceActions.DELETE_INVOICE),        
        map((action: invoiceActions.DeleteInvoiceAction) => action ),
        switchMap((action) => { 
            console.log('save invoice', action);           
            return this.invoiceService.delete(action.id).pipe(
                map((res: any) => new invoiceActions.DeleteInvoiceSuccessAction(action['id'])),
                catchError(error => of(new invoiceActions.DeleteInvoiceErrorAction(action['id'], error)))
            );
        })
    );    

    @Effect({dispatch: false})
    deleteInvoiceError: Observable<any> = this.actions$.pipe(
        ofType(invoiceActions.DELETE_INVOICE_ERROR),        
        map((action: invoiceActions.DeleteInvoiceAction) => action ),
        tap((action) => { 
            this.notificationsService.growlNotify('error','Erreur',action.error.message );
        })
    );  

    @Effect({ dispatch: false })
    deleteInvoiceSuccess$: Observable<any> = this.actions$.pipe(
        ofType(invoiceActions.DELETE_INVOICE_SUCCESS),        
        concatMap(action =>
            of(action).pipe(
              withLatestFrom(this.store.pipe(select('invoice')))
            )
        ),        
        tap(a => {
            this._location.back();
        })

    );
    @Effect()
    savePaiements: Observable<any> = this.actions$.pipe(
        ofType(invoiceActions.SAVE_PAIEMENTS),        
        map((action: invoiceActions.SavePaiementsAction) => action ),
        switchMap((action) => {                     
            return this.invoiceService.savePaiements(action.id, action.paiements).pipe(
                map((res: any) => new invoiceActions.SaveInvoiceSuccessAction(action['id'], res)),
                catchError(error => of(new invoiceActions.SaveInvoiceErrorAction(action['id'], error)))
            );
        })
    );   

    constructor(
        private actions$: Actions,
        private store: Store<any>,
        private router: Router,
        private invoiceService: InvoiceService,
        private prestationService: PrestationService,
        private notificationsService: NotificationsService,
        private _location: Location
    ) {}
}
